import { render, staticRenderFns } from "./SmSwitch.vue?vue&type=template&id=9a9ed412&scoped=true&"
import script from "./SmSwitch.vue?vue&type=script&lang=ts&"
export * from "./SmSwitch.vue?vue&type=script&lang=ts&"
import style0 from "./SmSwitch.vue?vue&type=style&index=0&id=9a9ed412&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a9ed412",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VSwitch})
